// adapters/manaswini.adapter.js

import { mergePaymentModes } from "../../../shared/helper/helper";

export const adaptManaswiniInvoice = (raw = {}) => {
  /* -------------------------------------------------
     Safe extraction
  ------------------------------------------------- */
  const firmInfo = raw.firmInfo || {};
  const customer = raw.customerDetail || {};
  const billingItems = Array.isArray(raw.billingItem) ? raw.billingItem : [];
  const summary = raw.billSummary || {};

  /* -------------------------------------------------
     Adapter output (STANDARD DTO)
  ------------------------------------------------- */
  return {
    /* -------------------------------------------------
       Report
    ------------------------------------------------- */
    reportName: raw.reportName || "",
    narration: raw.narration || "",
narration1: raw.narration1 || "",
    /* -------------------------------------------------
       Firm
    ------------------------------------------------- */
    firmInfo: {
      name: firmInfo.FIRM_NAME || "",
      address: firmInfo.FIRM_ADDRESS || "",
      city: firmInfo.FIRM_CITY || "",
      pincode: firmInfo.FIRM_PINCODE || "",
      phone: firmInfo.FIRM_PHONE || firmInfo.FIRM_MOBILE || "",
      email: firmInfo.FIRM_EMAIL || "",
      tin: firmInfo.FIRM_TIN || "",
      cin: firmInfo.FIRM_CIN || "",
      stateCode: firmInfo.FIRM_STATECODE || "",
      locationName: firmInfo.FIRM_LOCATIONNAME || "",
    },

    /* -------------------------------------------------
       Customer
    ------------------------------------------------- */
    customerDetail: {
      patientName: customer.patientName || "",
      age: customer.age ?? "",
      phono: customer.phono || "",
      address: customer.address || "",
      patientType: customer.patientType || "",
      section: customer.section || "",
      doctorName: customer.doctorName || "",
      roomName: customer.roomName || "",
      regNo: customer.regNumber || customer.regNo || "",
      ipNumber: customer.ipNumber || "",
      billNumber: customer.billNumber || "",
      billDate: customer.billDate || "",
      doa: customer.doa && customer.doa !== "null" ? customer.doa : "",
      dod: customer.dod && customer.dod !== "null" ? customer.dod : "",
      dep: customer.dep || "",
      plan: customer.insPlan || customer.plan || "",
      insurancePolicyNumber: customer.insurancePolicyNumber || "",
      insuranceCardNumber: customer.insuranceCardNumber || "",
  
    },

    /* -------------------------------------------------
       Billing Items
    ------------------------------------------------- */
    billingItems: billingItems.map((s = {}, i) => ({
      slNo: s.slNo ?? i + 1,
      serviceName: s.serviceName || s.label || "",
      charges: Number(s.charges ?? s.rate) || 0,
      units: Number(s.units) || 0,
      taxRate:
        s.taxRate !== undefined && s.taxRate !== null
          ? Number(s.taxRate)
          : null,
      gross: Number(s.gross) || 0,
      discount: Number(s.discount) || 0,
      netAmount: Number(s.netAmount) || 0,
    })),

    /* -------------------------------------------------
       Bill Summary
    ------------------------------------------------- */
    billSummary: {
      total: Number(summary.total) || 0,
      discount: Number(summary.discount) || 0,
      billAmount: Number(summary.billAmount) || 0,
      advancePayment: Number(summary.advancePayment) || 0,
      receivedAmount: Number(summary.paidAmount) || 0,
      payable: Number(summary.billAmount || 0)-Number(summary.advancePayment || 0) - Number(summary.paidAmount || 0),
      roundOff: Number(summary.roundOff) || 0,
      tax: Number(summary.tax) || 0,
      amountWords: summary.amountWords || "",
      generatedBy: summary.generatedBy || "",
      // paymentList: Array.isArray(summary.paymentsList)
      //   ? summary?.paymentsList.map((p = {}) => ({
      //       mode: p.paymentMode || "",
      //       receivedAmount: p.paymentTotalMoney || 0.00,
      //     }))
      //   : [],
      paymentList:mergePaymentModes(summary.invoicePayments || []),
    },
  };
};
